<template>
  <PubPage>
    <div class="user-dictionary">
      <div class="user-dictionary-left">
        <section class="pub-card">
          <PubPageTitle title="字典列表" />
          <a-spin :spinning="loadingLeft">
            <div class="dictionary-type">
              <div class="d-nav">
                <div
                  class="d-type-item"
                  v-for="(item, index) in codeList"
                  :key="index"
                  :class="{ active: activeKey == item.code }"
                  @click="chosedType(item.code)"
                >
                  {{ item.name }}({{ item.code }})
                </div>
              </div>
            </div>
          </a-spin>
        </section>
      </div>
      <div class="user-dictionary-right">
        <section class="pub-card">
          <PubPageTitle title="字典明细">
            <template slot="titleRight">
              <a-button
                type="primary"
                class="btn-green"
                icon="plus-circle"
                @click="add('add')"
              >
                新增明细
              </a-button>
            </template>
          </PubPageTitle>
          <div class="user-dictionary-list">
            <BasicTable
              :columns="columns"
              bordered
              :dataSource="itemList"
              :loading="loading"
              :search="false"
              :pagination="false"
            >
              <template slot="index" slot-scope="{ index }">
                {{ index + 1 }}
              </template>
              <template slot="options" slot-scope="{ record }">
                <div class="pub-options">
                  <a @click="add('edit', record)">
                    <a-icon type="form" />编辑
                  </a>
                  <a @click="deleteDictionary(record.id)" class="red">
                    <a-icon type="delete" />删除
                  </a>
                </div>
              </template>
            </BasicTable>
          </div>
        </section>
      </div>
    </div>
    <AddDictionary ref="addDictionaryModal" @ok="moduleOk" />
  </PubPage>
</template>

<script>
import { Setting } from "@/api";
import AddDictionary from "./AddDictionary";

const columns = [
  {
    title: "序号",
    dataIndex: "index",
    align: "center",
    width: 50,
    hideInSearch: true,
    scopedSlots: true,
  },
  {
    title: "字典名称",
    dataIndex: "baseName",
    align: "center",
  },
  {
    title: "字典值",
    dataIndex: "baseCode",
    align: "center",
  },
  {
    title: "排序",
    dataIndex: "seq",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "options",
    width: 130,
    align: "center",
    scopedSlots: true,
  },
];
export default {
  components: { AddDictionary },
  data() {
    return {
      parenKey: "",
      activeKey: "",
      codeList: [],
      itemList: [],
      columns,
      loadingLeft: false,
      loading: false,
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    // 操作后
    chosedParentType(data) {
      this.parenKey = data.title;
      this.chosedType(data[0].code);
    },
    // 操作后
    chosedType(key) {
      this.activeKey = key;
      this.getItem();
    },

    // 获取左侧字典列表
    getList() {
      this.loadingLeft = true;
      Setting.sysCodeTypeShowTree().then(res => {
        if (res.code == this.config.pubCode) {
          this.codeList = res.data;
          this.chosedParentType(res.data);
        }
        this.loadingLeft = false;
      });
    },

    // 获取右侧字典明细
    getItem() {
      this.loading = true;
      Setting.sysCodeTypeFindByCode({ code: this.activeKey }).then(res => {
        if (res.code == this.config.pubCode) {
          this.itemList = res.data;
        }
        this.loading = false;
      });
    },
    // 弹窗操作
    add(type, data) {
      this.$refs.addDictionaryModal.open(type, data, this.activeKey);
    },
    moduleOk(data) {
      if (data) {
        this.getItem();
      }
    },
    // 删除字典明细
    deleteDictionary(id) {
      this.pubMsg.confirm("是否确定删除此数据？").then(() => {
        this.loading = true;
        Setting.sysCodeTypeDelete({ ids: id }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("删除成功！", "success");
            this.getItem();
          }
          this.loading = false;
        });
      });
    },
  },
};
</script>
<style lang="less">
@import "./style.less";
</style>
